module.exports = __webpack_public_path__ + "static/media/qrCode_area.90d13dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/qrCode_area.png
// module id = 1297
// module chunks = 110